import React from 'react';
import { CONTACT_INFO, NAV_LINKS } from '../constants';
import { Package, Mail, Phone, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  // Split links for the two columns
  const leftLinks = NAV_LINKS.slice(0, 4); // Home, How It Works, Services, Pricing
  const rightLinks = NAV_LINKS.slice(4);   // FAQ, Contact

  return (
    <footer className="bg-slate-900 text-slate-300 py-12 md:py-16 border-t border-slate-800 mb-20 md:mb-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">

          {/* Brand Column */}
          <div className="space-y-4">
            <div className="flex items-center gap-2 text-white mb-2">
              <Package className="h-6 w-6" />
              <span className="font-bold text-xl">OTL Express</span>
            </div>
            <p className="text-sm leading-relaxed text-slate-400">
              Your trusted partner for shipping packages from Sri Lanka to the Maldives. Fast, secure, and reliable.
            </p>
          </div>

          {/* Links Column - Split into 2 */}
          <div className="lg:col-span-1">
            <h4 className="text-white font-bold mb-4 md:mb-6">Quick Links</h4>
            <div className="grid grid-cols-2 gap-4">
              <ul className="space-y-3">
                {leftLinks.map(link => (
                  <li key={link.name}>
                    <Link to={link.href} className="text-sm text-slate-400 hover:text-white transition-colors block py-1">
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
              <ul className="space-y-3">
                {rightLinks.map(link => (
                  <li key={link.name}>
                    <Link to={link.href} className="text-sm text-slate-400 hover:text-white transition-colors block py-1">
                      {link.name}
                    </Link>
                  </li>
                ))}
                <li>
                  <Link to="/rules" className="text-sm text-slate-400 hover:text-white transition-colors block py-1">
                    Terms of Service
                  </Link>
                </li>
                <li>
                  <Link to="/rules" className="text-sm text-slate-400 hover:text-white transition-colors block py-1">
                    Privacy Policy
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Contact Sri Lanka */}
          <div>
            <h4 className="text-white font-bold mb-4 md:mb-6">Sri Lanka Office</h4>
            <ul className="space-y-3 md:space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-brand-500 shrink-0 mt-0.5" />
                <span>{CONTACT_INFO.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-brand-500 shrink-0" />
                <span>Ocean Trade: <br /><a href={`tel:${CONTACT_INFO.phoneSriLanka}`} className="hover:text-white">{CONTACT_INFO.phoneSriLanka}</a></span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-brand-500 shrink-0" />
                <a href={`mailto:${CONTACT_INFO.email}`} className="hover:text-white break-all">{CONTACT_INFO.email}</a>
              </li>
            </ul>
          </div>

          {/* Contact Maldives */}
          <div>
            <h4 className="text-white font-bold mb-4 md:mb-6">Maldives Support</h4>
            <ul className="space-y-3 md:space-y-4 text-sm">
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-brand-500 shrink-0" />
                <span>Male: <br /><a href={`tel:${CONTACT_INFO.phoneMaldives}`} className="hover:text-white">{CONTACT_INFO.phoneMaldives}</a></span>
              </li>
            </ul>
          </div>

        </div>

        <div className="border-t border-slate-800 mt-10 md:mt-12 pt-8 text-center text-xs text-slate-500">
          <p>&copy; {new Date().getFullYear()} OTL Express. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;